<template>
  <div>
    <TopBar :isCollapse="isCollapse"/>
    <Sidebar @collapseChnage="onCollapse"/>
    <div class="app-main" :class="[isCollapse ? 'collapse' : '']">
      <div class="app-main-container">
        <div class="app-main-header">{{title}}</div>
        <div class="app-main-page">
          <keep-alive :include="cachedViews">
            <router-view :key="key"/>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Sidebar from './components/SideBar/SideBar';
  import TopBar from './components/TopBar/index';

  export default {
    components: {Sidebar, TopBar},
    data() {
      return {
        isCollapse: false
      }
    },
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        return this.$route.fullPath
      },
      title() {
        return this.$route.meta.title
      }
    },
    methods: {
      onCollapse(isCollapse) {
        this.isCollapse = isCollapse;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/variables";

  .app-main {
    width: calc(100vw - 150px);
    left: $sideBarWidth;
    top: 61px;
    height: calc(100vh - 61px);
    background: #f3f3f4;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    transition: all .3s ease;
    &.collapse {
      width: calc(100vw - 54px);
      left: $sideBarMiniWidth;
    }
  }

  .app-main-container {
    width: 100%;
    height: 100%;
    background: #fff;
  }

  .app-main-header {
    background: #f5f5f5;
    border-top: 2px solid #e7eaec;
    padding: 15px 20px;
    font-weight: bold;
    font-size: 14px;
  }

  .app-main-page {
    background: #fff;
    height: calc(100% - 51px);
    padding:15px 20px;
    box-sizing: border-box;
    overflow-y: auto;
  }

</style>



// WEBPACK FOOTER //
// src/layout/index.vue